export default __webpack_public_path__ + "img/0be326b1ff50b27eb75d1a0c52c994dc.png";